import { useContext } from 'react';

import { UserPersistedFiltersContext } from './UserFiltersContext';
import { GetPersistedFilters } from './UseGetPersistedFilters';

export const useUserPersistedFilters = (): GetPersistedFilters => {
  const userFilters = useContext(UserPersistedFiltersContext);

  if (!userFilters) {
    throw new Error('Missing <UserPersistedFiltersProvider />');
  }
  return userFilters;
};
